exports.url = "http://alarmconnect.nl/api"

// exports.url = "http://localhost:3030"
